import React, {useRef, useState, useEffect} from 'react';
import {Button, Card, Form} from 'react-bootstrap';
import Select from 'react-select';
import {PfButton} from '@profabric/react-components';

export default function ModalAddDriver(props) {
  const _opt1 = [
    {value: 'รถสองแถว', label: 'รถสองแถว'},
    {value: 'รถปิ๊คอัพ 2 ประตู', label: 'รถปิ๊คอัพ 2 ประตู'},
    {value: 'รถปิ๊คอัพ 4 ประตู', label: 'รถปิ๊คอัพ 4 ประตู'},
    {value: 'รถเก๋ง', label: 'รถเก๋ง'},
    {value: 'รถตู้', label: 'รถตู้'}
  ];
  const _opt2 = [
    {value: 'DAP', label: 'DAP'},
    {value: 'IP1', label: 'IP1'},
    {value: 'IP2', label: 'IP2'}
  ];

  const viewtype = [
    {label: 'รถสองแถว', value: 'CS_1'},
    {label: 'รถปิ๊คอัพ 4 ประตู', value: 'CS_3'},
    {label: 'รถเก๋ง', value: 'CS_4'},
    {label: 'รถตู้', value: 'CS_22'},
    {label: 'รถปิ๊คอัพ 2 ประตู', value: 'CS_2'}
  ];

  useEffect(() => {
    if (props.mode === 'edit') {
      console.log(props.item);
      setState({...props.item, b64: ''});
    }
  }, []);

  const [file, setFile] = useState([
    {id: 1, file: null},
    {id: 2, file: null}
  ]);
  const [error, setError] = useState('');
  const [state, setState] = useState({
    CAR_ID: '',
    PLATE_NO: '',
    NAME: '',
    TYPE: '',
    SITE: '',
    PHONE: '',
    CARD_ID: '',
    b64: '',
    OWNER_ID: '',
    OWNER_NAME: '',
    VIEWTYPE: []
  });

  const handleValidation = () => {
    let errors = '';
    let formIsValid = true;

    if (state.PLATE_NO === '') {
      formIsValid = false;
      errors = errors + 'ทะเบียน, ';
    }
    if (state.NAME === '') {
      formIsValid = false;
      errors = errors + 'ชื่อ, ';
    }
    if (state.TYPE === '') {
      formIsValid = false;
      errors = errors + 'ประเภท, ';
    }
    if (state.SITE === '') {
      formIsValid = false;
      errors = errors + 'สำนักงาน, ';
    }
    if (state.PHONE === '') {
      formIsValid = false;
      errors = errors + 'เบอร์โทร, ';
    }
    if (state.CARD_ID === '') {
      formIsValid = false;
      errors = errors + 'เลขบัตรปชช, ';
    }
    if (file[0].file === null && props.mode === 'add') {
      formIsValid = false;
      errors = errors + 'รูปรถ, ';
    }
    if (file[1].file === null && props.mode === 'add') {
      formIsValid = false;
      errors = errors + 'รูปคน, ';
    }

    if (!formIsValid) setError(`Required: ${errors}`);
    return formIsValid;
  };

  const handleSubmit = async () => {
    if (handleValidation()) {
      setLoading(true);
      try {
        console.log(state);
        const result = await props.onAdd(state, file);
        setLoading(false);
      } catch (error) {}
    }
  };

  const handleEdit = async () => {
    if (handleValidation()) {
      setLoading(true);
      try {
        console.log(state);
        const result = await props.onEdit(state, file);
        setLoading(false);
      } catch (error) {}
    }
  };

  const handleDelete = async () => {
    try {
      console.log(state);
      const result = await props.onDelete(state);
      setLoading(false);
    } catch (error) {}
  };

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file); //ปัญหา
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const photoUpload = async (e, id) => {
    e.preventDefault();
    const _file = e.target.files[0];
    if (_file) {
      let base64 = await convertToBase64(_file);
      if (id === 1) {
        setState((prevState) => ({...prevState, b64: base64}));
      }
      const temp = file.map((e) => {
        if (e.id === id) return {...e, file: _file};
        else return e;
      });
      console.log(temp);
      setFile(temp);
    }
  };

  const [isLoading, setLoading] = useState(false);
  return (
    <div>
      <Form>
        <div className="row">
          <Form.Group className="mb-6 col-md-4">
            <Select
              menuPortalTarget={document.body}
              styles={{menuPortal: (base) => ({...base, zIndex: 9999})}}
              placeholder={'ประเภทรถ'}
              options={_opt1}
              value={_opt1.find((v) => v.value === state.TYPE)}
              onChange={(v) => {
                setState((prevState) => ({
                  ...prevState,
                  TYPE: v.value
                }));
              }}
            />
          </Form.Group>
          <Form.Group className="mb-6 col-md-4">
            <Select
              menuPortalTarget={document.body}
              styles={{menuPortal: (base) => ({...base, zIndex: 9999})}}
              placeholder={'สำนักงาน'}
              options={_opt2}
              value={_opt2.find((v) => v.value === state.SITE)}
              onChange={(v) => {
                setState((prevState) => ({
                  ...prevState,
                  SITE: v.value
                }));
              }}
            />
          </Form.Group>
          <Form.Group className="mb-3 col-md-4">
            <Form.Control
              type="text"
              value={state.CARD_ID}
              onChange={(event) => {
                setState((prevState) => ({
                  ...prevState,
                  CARD_ID: event.target.value
                }));
              }}
              placeholder="เลขบัตรประชาชน"
            />
          </Form.Group>
          <Form.Group className="mb-3 col-md-4">
            <Form.Control
              type="text"
              placeholder="ทะเบียน"
              value={state.PLATE_NO}
              onChange={(event) => {
                setState((prevState) => ({
                  ...prevState,
                  PLATE_NO: event.target.value
                }));
              }}
            />
          </Form.Group>
          <Form.Group className="mb-3 col-md-4">
            <Form.Control
              type="text"
              placeholder="ชื่อ"
              value={state.NAME}
              onChange={(event) => {
                setState((prevState) => ({
                  ...prevState,
                  NAME: event.target.value
                }));
              }}
            />
          </Form.Group>
          <Form.Group className="mb-3 col-md-4">
            <Form.Control
              type="text"
              value={state.PHONE}
              onChange={(event) => {
                setState((prevState) => ({
                  ...prevState,
                  PHONE: event.target.value
                }));
              }}
              placeholder="เบอร์โทร"
            />
          </Form.Group>
          <Form.Group className="mb-3 col-md-8">
            <Select
              menuPortalTarget={document.body}
              styles={{menuPortal: (base) => ({...base, zIndex: 9999})}}
              placeholder={'เจ้าของรถ'}
              options={props.owner}
              value={props.owner.find((v) => v.value === state.OWNER_ID)}
              onChange={(v) => {
                setState((prevState) => ({
                  ...prevState,
                  OWNER_ID: v.value,
                  OWNER_NAME: v.label,
                }));
              }}
            />
          </Form.Group>
          <Form.Group className="mb-3 col-md-12">
            <div className="custom-file">
              <input
                type="file"
                onChange={(e) => {
                  photoUpload(e, 1);
                }}
                className="custom-file-input"
                accept=".jpef, .png, .jpg"
                id="customFile"
              />
              <label className="custom-file-label" htmlFor="customFile">
                {file[0].file
                  ? file[0].file.name
                  : 'รูปรถ | ขนาดภาพไม่เกิน 4MB'}
              </label>
            </div>
          </Form.Group>
          <Form.Group className="mb-3 col-md-12">
            <div className="custom-file">
              <input
                type="file"
                onChange={(e) => {
                  photoUpload(e, 2);
                }}
                className="custom-file-input"
                accept=".jpef, .png, .jpg"
                id="customFile"
              />
              <label className="custom-file-label" htmlFor="customFile">
                {file[1].file
                  ? file[1].file.name
                  : 'รูปคน | ขนาดภาพไม่เกิน 4MB'}
              </label>
            </div>
          </Form.Group>
          <Form.Group className="mb-3 col-md-12">
            <Card className="col-12">
              <Card.Body>
                <div
                  className="container"
                  style={{
                    height: '28vh',
                    width: '100%',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center top',
                    backgroundImage:
                      state.b64 === ''
                        ? 'url("https://api-passport.advanceagro.net/img/car_temp.png")'
                        : ''
                  }}
                >
                  <img
                    className="rounded mx-auto d-block"
                    style={{
                      maxHeight: '100%',
                      maxWidth: '100%'
                    }}
                    src={state.b64 !== '' ? state.b64 : ''}
                  ></img>
                </div>
              </Card.Body>
            </Card>
          </Form.Group>
          <Form.Group className="mb-3 col-md-12">
            <Select
              isMulti
              menuPortalTarget={document.body}
              styles={{menuPortal: (base) => ({...base, zIndex: 9999})}}
              menuPlacement="top"
              className="basic-multi-select"
              classNamePrefix="select"
              placeholder={'รับงานประเภท'}
              options={viewtype}
              value={viewtype.filter((e) => {
                return state.VIEWTYPE ? state.VIEWTYPE.includes(e.value) : false;
              })}
              onChange={(v) => {
                setState((prevState) => {
                  console.log(v);
                  return {
                    ...prevState,
                    VIEWTYPE: v.map((e) => e.value)
                  };
                });
              }}
            />
          </Form.Group>
        </div>
      </Form>
      <p className="text-danger">{error}</p>
      <PfButton
        className={props.mode === 'add' ? 'd-inline mr-1 col-5' : 'd-none'}
        theme="success"
        block
        loading={isLoading}
        type="button"
        onClick={handleSubmit}
      >
        เพิ่มคนขับรถ
      </PfButton>
      <PfButton
        className={props.mode === 'edit' ? 'd-inline mr-1 col-5' : 'd-none'}
        theme="success"
        block
        loading={isLoading}
        type="button"
        onClick={handleEdit}
      >
        แก้ไขข้อมูล
      </PfButton>
      <PfButton
        className={props.mode === 'edit' ? 'd-inline ml-1 col-5' : 'd-none'}
        theme="danger"
        block
        loading={isLoading}
        type="button"
        onClick={handleDelete}
      >
        ลบ
      </PfButton>
    </div>
  );
}
